import { IAPIPerson, Person } from "./person.model";
import { Profile } from "./profile.model"
import { Status } from "./status.model"

export class Customer extends Person {

    constructor(_id?: number, _name?: string, _occupation?: string, _salary?: number, _salaryDay?: number, _icNumber?: string, _contactNo?: string,
        _remark?: string, _ctosNumber?: string, _ctosStatus?: string, _status?: Status[], _dateCreated?: Date, _handlerId?: string, _companyId?: number,
        _customerCode?: string, _companyCode?: string, _reserve?: number, _badDebt?: number, _address?: string, _profiles?: Profile[],
        _lastformJDate?: Date, _needAttention?: boolean, _epfDate?: Date, _address2?: string, _verified?: boolean, _dob?: Date, _verifiedBy?: string,
        _otherId?: string, _race?: string, _gender?: string, _verifiedOn?: Date);
    constructor(_id: number, private _name: string, _occupation: string, _salary: number, _salaryDay: number, _icNumber: string, private _contactNo: string,
        _remark: string, private _ctosNumber: string, private _ctosStatus: string, _status: Status[], _dateCreated: Date, private _handlerId: string, _companyId: number,
        _customerCode: string, _companyCode?: string, _reserve?: number, _badDebt?: number, private _address?: string, private _profiles?: Profile[],
        private _lastformJDate?: Date, private _needAttention?: boolean, private _epfDate?: Date, private _address2?: string, private _verified?: boolean, private _dob?: Date, private _verifiedBy?: string, private _otherId?: string, private _race?: string, private _gender?: string, private _verifiedOn?: Date) { super(_id, _occupation, _salary, _salaryDay, _icNumber, _remark, _status, _dateCreated, _companyId, _customerCode, _companyCode, _reserve, _badDebt) }

    set Name(name: string) { this._name = name }
    get Name(): string { return this._name }

    set ContactNo(contactNo: string) { this._contactNo = contactNo }
    get ContactNo(): string { return this._contactNo }

    set CtosNumber(ctosNumber: string) { this._ctosNumber = ctosNumber }
    get CtosNumber(): string { return this._ctosNumber }

    set CtosStatus(ctosStatus: string) { this._ctosStatus = ctosStatus }
    get CtosStatus(): string { return this._ctosStatus }

    set HandlerId(handlerId: string) { this._handlerId = handlerId }
    get HandlerId(): string { return this._handlerId }

    set Address(address: string) { this._address = address }
    get Address(): string { return this._address }

    set Profiles(_profiles: Profile[]) { this._profiles = _profiles }
    get Profiles(): Profile[] { return this._profiles }

    set LastFormJDate(lastformJDate: Date) { this._lastformJDate = lastformJDate }
    get LastFormJDate(): Date { return this._lastformJDate }

    set NeedAttention(needAttention: boolean) { this._needAttention = needAttention }
    get NeedAttention(): boolean { return this._needAttention }

    set EPFDate(epfDate: Date) { this._epfDate = epfDate }
    get EPFDate(): Date { return this._epfDate }

    set Address2(address2: string) { this._address2 = address2 }
    get Address2(): string { return this._address2 }

    set Verified(verified: boolean) { this._verified = verified }
    get Verified(): boolean { return this._verified }

    set DOB(dob: Date) { this._dob = dob }
    get DOB(): Date { return this._dob }

    set VerifiedBy(verifiedBy: string) { this._verifiedBy = verifiedBy }
    get VerifiedBy(): string { return this._verifiedBy }

    get OtherID(): string { return this._otherId }
    set OtherID(value: string) { this._otherId = value }

    get Gender(): string { return this._gender }
    set Gender(value: string) { this._gender = value }

    get Race(): string { return this._race }
    set Race(value: string) { this._race = value }

    get VerifiedOn(): Date { return this._verifiedOn }
    set VerifiedOn(value: Date) { this._verifiedOn = value }

    toUpdate() {
        const cust = this.toStaffUpdate();
        cust.Name = this._name;
        cust.ICNumber = this._icNumber;
        cust.ContactNo = this._contactNo;
        cust.HandlerId = this._handlerId;
        cust.CompanyId = this._companyId;
        return cust;
    }

    toStaffUpdate() {
        const cust = new Customer();
        cust.Address = this._address;
        cust.Address2 = this._address2;
        cust.OtherID = this._otherId;
        cust.Race = this._race;
        cust.Gender = this._gender;
        return cust;
    }
}

export interface IAPICustomer extends IAPIPerson {
    name: string;
    icNumber: string;
    contactNo: string;
    ctosNumber: string;
    ctosStatus: string;
    handler: string;
    address: string;
    profileIds: number[];
    lastFormJDate: string;
    needAttention: boolean;
    epfDate: string;
    address2: string;
    // verified: boolean;
    dob: string;
    // verifiedBy: string;
    otherId: string;
    race: string;
    gender: string;
    // verifiedOn: string;
}